import React, {  useRef, useState } from "react";
import Slider from "react-slick";
import { AnnouncementsIcon, NewBackArrowIconEventPage, NewNextArrowIconEventPage } from "../../utils/icons";
import { useHistory } from 'react-router-dom';
import SkeletonLoder from "../common/skeletonLoder";
import LazyImage from "../common/LazyImage/LazyImage";
// Assuming these are in your styles file, you may need to add/update them
import { 
  Layout, Container, SliderContainer, 
  ReservedButton, OuterCardContainer, 
  CompanyCard
} from "../UserDashboard/styles";
import { ImageUrl } from "../../utils/constants";
import PropTypes from "prop-types";
import parse from "react-html-parser";
import { InitiativeGraph } from "./styles";
import CustomNotification from "../ChallengeDetailsV2/customNotification";
import moment from "moment";
import CircularProgressBar from "../common/CircularProgressBar/CircularProgressBar";




const InitiativeSlider = ({
  title = "Recurring",
  data = [],
  showArrows = true,
  cardRender,
  showDots = true,
  loading = false,
  icon = <AnnouncementsIcon/>,
  companyId,
}) => {
  const sliderRef = useRef(null);
  const [currentSlide, setCurrentSlide] = useState(1);
  const history = useHistory();
  const [notificationInitiative, setNotificationInitiative] = useState(null);
  

  window.console.log("notificationInitiative",notificationInitiative)

  const handleBeforeChange = (_, newIndex) => {
    setCurrentSlide(newIndex + 1);
  };


  window.console.log("data",data)


  
  
  const getDaysRemaining = (endDateString) => {
    if (!endDateString) return 0;
    
    const today = moment().startOf('day');
    const endDate = moment(endDateString).startOf('day');
    const daysDifference = endDate.diff(today, 'days');
    return daysDifference > 0 ? daysDifference : 0;
  };


  const sliderSettings = {
    dots: showDots,
    infinite: false,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    draggable: true,
    adaptiveHeight: false,
    variableWidth: false,
    beforeChange: handleBeforeChange,
    responsive: [
      {
        breakpoint: 1252,
        settings: { dots: showDots, infinite: false, slidesToShow: 1, arrows: true },
      },
      {
        breakpoint: 600,
        settings: { dots: showDots, infinite: false, slidesToShow: 1, arrows: true },
      },
    ],
  };


  if (loading) return <SkeletonLoder width={"1248px"} height={"450px"} />;

  return (
    <OuterCardContainer isOuterpadding={data.length > 1 ? "0px 20px 46px 20px" : "0px 20px 20px 20px"}>
      <Layout margin="20px 0 0 0" padding="0px">
        <div className="headingMain">
          <div style={{ gap: "12px" }} className="heading">
            {icon}
            {title}
          </div>

          { showArrows && data.length > 1 && (
            <div className="arrows">
              {currentSlide > 1 ? (
                <div className="iconBackground" onClick={() => sliderRef.current?.slickPrev()}>
                  {NewBackArrowIconEventPage("#DA6C74")}
                </div>
              ):null}
              <div className="text">
                {currentSlide}/{data.length}
              </div>
              {currentSlide < data.length ? (
                <div className="iconBackground" onClick={() => sliderRef.current?.slickNext()}>
                  {NewNextArrowIconEventPage("#DA6C74")}
                </div>
              ):<div className="iconPlaceholder"></div>}
            </div>
          )}
        </div>

        <Container style={{border: "none",borderRadius:"8px",marginTop:"16px",height:"344px"}}>
          <SliderContainer display="flex" content="center" marginValue="0">
            <Slider {...sliderSettings} ref={sliderRef}>
              {data.map((item, index) =>
                cardRender ? (
                  cardRender(item, index) 
                ) : (
                  <div className="card" key={index}>
                    <CompanyCard detailsCardPadding="20px" 
                      isCursorPointer={"default"}
                    >
                      <LazyImage className="imageCardUserDashboard" src={`${ImageUrl}/${item?.thumbnail}`} alt="event" />
                      <div className="detailsCard">
                        <div className="title" style={{marginBottom:'14px'}}>{item?.initiative_name }</div>
                        <div className="details" style={{marginBottom:"0px"}}>{parse(item?.about)}</div>
                        <InitiativeGraph>
                          <div style={{ position: "relative", flexShrink: "0" }}>
                            <CircularProgressBar
                              percentage={item?.user_initiative_taken_percentage || 0}
                              color={'#75B084'}
                              size={160}
                              innerCircle={"#2F6C42"}
                              strokeWidth={12}
                              outerStroke={"#75B084"}
                            />
                          </div>
                          <div style={{ fontSize: "16px", color: "#184A61" }}>
                            <div className="heading">Users Completed :<span className="sub-heading">{ item.total_participation} </span></div>
                            <div className="heading">Users Invited : <span  className="sub-heading">{item.user_count} </span></div>
                            <div className="lastHeading">Ends In : <span  className="sub-heading">{getDaysRemaining(item?.end_date)} Days </span></div>
                          </div>
                        </InitiativeGraph>

                        <div style={{ display: "flex", gap: "12px", marginTop: "auto" }}>
                          <ReservedButton 
                            style={{ flex: 1, height: "40px" }}
                            onClick={() => history.push(`/company/initiative-details/${item?.company_initiative_id}`)}
                          >
                            View Details
                          </ReservedButton>
                          <ReservedButton 
                            // active={1} 
                            style={{ flex: 1, height: "40px" }}
                            onClick={() => setNotificationInitiative(item)}

                          >
                            Send Notification
                          </ReservedButton>
                        </div>
                      </div>
                    </CompanyCard>
                  </div>
                )
              )}
            </Slider>
          </SliderContainer>
        </Container>
      </Layout>
      {notificationInitiative && (
        <CustomNotification
          showModal={!!notificationInitiative}
          onClose={() => setNotificationInitiative(null)}
          type="initiative"
          companyInitiativeId={notificationInitiative?.company_initiative_id || notificationInitiative?.id}
          companyId={companyId}
        />
      )}
    </OuterCardContainer>
  );
};


InitiativeSlider.propTypes =
{
  title: PropTypes.string,
  data: PropTypes.array.isRequired,
  cardRender: PropTypes.func,
  showArrows: PropTypes.bool,
  showDots: PropTypes.bool,
  myAnnouncementCard: PropTypes.bool,
  myActicityCard: PropTypes.bool,
  myFocusCard: PropTypes.bool,
  refreshAnnouncements: PropTypes.func,
  activeFocusKey: PropTypes.string,
  loading: PropTypes.bool,
  icon: PropTypes.node,
  companyId: PropTypes.number,
  CatgoryName:PropTypes.string,
  CategoryType:PropTypes.string,
}

export default InitiativeSlider;